(function () {
  'use strict';
  angular.module('vcdms.vcfile')
    .component('imagecapture', {
      restrict: 'E',
      bindings: {
        filehandle: '=',
        parentsave: '&',
        label: '@?',
        color: '@?',
        consultid: '<?',
        examid: '<?',
        clientid: '<?',
        filecat: '@?'
      },
      template: `
          <input type="file" name="imgc{{vm.captureid}}" id="imgc{{vm.captureid}}"
                 class="inputfile"  accept="image/*;capture=camera" />
          <label class="btn btn-{{vm.color || 'primary'}}" for="imgc{{vm.captureid}}"
                 uib-tooltip="Kamera oder Photo upload"><i class="fa fa-camera"></i> {{vm.label || ''}}
            <span ng-show="vm.saved"><i class="fa fa-check text-success"></i></span>
            <span ng-show="vm.error"><i class="fa fa-warning text-danger"></i></span>
          </label>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Fileupload', '$element', '$timeout',
        function ($log, $http, Rlog, Fileupload, $element, $timeout) {
          let vm = this;
          vm.upload = upload;

          // create unique identifiers for fileupload input ids


          // init
          vm.$onInit = function () {
            vm.captureid = guid();

            if (angular.isUndefined(vm.clientid)) {
              vm.clientid = '';
            }
            if (angular.isUndefined(vm.consultid)) {
              vm.consultid = '';
            }
            if (angular.isUndefined(vm.examid)) {
              vm.examid = '';
            }

            if (angular.isUndefined(vm.filecat)) {
              vm.filecat = 'imagecapture';
            }
            $element.bind('change', function (e) {
              vm.icfile = (e.srcElement || e.target).files[0];
              vm.upload();
            });
          };


          // vm.consultid, etc might be late propagating
          vm.$onChanges = function (changes) {
            if (!changes.isFirstChange) {
              if (angular.isDefined(changes.consultid)) {
                vm.consultid = changes.consultid.currentValue;
              }
              if (angular.isDefined(changes.clientid)) {
                vm.clientid = changes.clientid.currentValue;
              }
              if (angular.isDefined(changes.examid)) {
                vm.examid = changes.examid.currentValue;
              }
            }
          };


          function upload() {
            $log.debug('vm.filecat', vm.filecat);
            Fileupload.uploadFileToUrl(vm.icfile, vm.filecat, vm.consultid, vm.clientid, vm.examid)
              .then(function () {
                vm.saved = true;
                $timeout(function () {
                  delete vm.saved;
                }, 5000);
              }, function (err) {
                $log.error('Fileupload error: ', err);
                vm.error = true;
                $timeout(function () {
                  delete vm.error;
                }, 5000);
              });
          }

          function guid() {
            function s4() {
              return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
            }

            return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
              s4() + '-' + s4() + s4() + s4();
          }

        }] // controller
    }); // component


  // klammerfriedhof
}());
